import React from 'react';

const AlternateThemeContext = React.createContext();

export default AlternateThemeContext;
